export default {
	singleCalculation: {},
	calculationInterface: null
}